const Disclaimer = () => {
  return (
    <div className="!py-4 text-white">
      <div className="container">
        <div>
          <p style={{ textAlign: 'center', lineHeight: '0.23in', marginBottom: '0in' }}>
            <span style={{ border: 'none', padding: '0in' }}>
              <span lang="en-US">
                <strong>DISCLAIMER</strong>
              </span>
            </span>
          </p>
          <p style={{ textAlign: 'justify', lineHeight: '0.23in', marginBottom: '0in' }}>
            <br />
          </p>
          <p style={{ textAlign: 'justify', lineHeight: '100%', marginBottom: '0.18in' }}>
            <span style={{ border: 'none', padding: '0in' }}>
              <span lang="en-US">This website is owned and operated by APOLO LDA</span>
            </span>
            <span>
              <span lang="en-US">&nbsp;(“Company,” “we,” or “us”).</span>
            </span>
          </p>
          <p style={{ textAlign: 'justify', lineHeight: '100%', marginBottom: '0.18in' }}>
            <span>
              <span lang="en-US">
                This Disclaimer, along with the Terms of Use and Privacy Policy, governs your access
                to and use of the website including any content, functionality and services offered
                on or through the “Website”, whether as a guest or a registered user.
              </span>
            </span>
          </p>
          <p style={{ textAlign: 'justify', lineHeight: '100%', marginBottom: '0.18in' }}>
            <span>
              <span lang="en-US">
                Please read the Disclaimer carefully before you start to use the Website. By using
                the Website or by clicking to accept or agree to the Terms of Use when this option
                is made available to you, you accept and agree to be bound and abide by the
                Disclaimer. If you do not want to agree to the Privacy Policy, you must not access
                or use the Website.
              </span>
            </span>
          </p>
          <p style={{ textAlign: 'justify', lineHeight: '0.23in', marginBottom: '0in' }}>
            <br />
          </p>
          <p style={{ textAlign: 'justify', lineHeight: '0.23in', marginBottom: '0in' }}>
            <span style={{ border: 'none', padding: '0in' }}>
              <span lang="en-US">
                <strong>Not Professional Advice</strong>
              </span>
            </span>
          </p>
          <p style={{ textAlign: 'justify', lineHeight: '100%', marginBottom: '0.18in' }}>
            <br />
            &nbsp;
          </p>
          <p style={{ textAlign: 'justify', lineHeight: '100%', marginBottom: '0.18in' }}>
            <span>
              <span lang="en-US">
                The information contained on this Website and the resources available through this
                website is not intended as, and shall not be understood or construed as,
                professional advice. While the Tutors are professionals which go through a vetting
                process and the information provided during classes relates to issues within their
                area of professionalism, the information presented is not a substitute for advice
                from a professional who is aware of the facts and circumstances of your individual
                situation.
              </span>
            </span>
          </p>
          <p style={{ textAlign: 'justify', lineHeight: '100%', marginBottom: '0.18in' }}>
            <span>
              <span lang="en-US">
                We have done our best to ensure that the information provided on this Website and
                the resources available are accurate and provide valuable information. Regardless of
                anything to the contrary, nothing available on or through this Website should be
                understood as a recommendation that you should not consult with a professional to
                address your particular information. The Company expressly recommends that you seek
                advice from a professional.
              </span>
            </span>
          </p>
          <p style={{ textAlign: 'justify', lineHeight: '100%', marginBottom: '0.18in' }}>
            <span>
              <span lang="en-US">
                Neither the Company nor any of its&nbsp;employees or owners shall be held liable or
                responsible for any errors or omissions on this website or for any damage you may
                suffer as a result of failing to seek competent advice from a professional who is
                familiar with your situation.
              </span>
            </span>
          </p>
          <p style={{ textAlign: 'justify', lineHeight: '0.23in', marginBottom: '0in' }}>
            <span style={{ border: 'none', padding: '0in' }}>
              <span lang="en-US">
                <strong>No Professional-Client Relationship</strong>
              </span>
            </span>
          </p>
          <p style={{ textAlign: 'justify', lineHeight: '0.23in', marginBottom: '0in' }}>
            <br />
          </p>
          <p style={{ textAlign: 'justify', lineHeight: '100%', marginBottom: '0.18in' }}>
            <span>
              <span lang="en-US">
                Your use of this Website – including implementation of any suggestions set out in
                this Website and/or use of any resources available on this Website – does not create
                a professional-client relationship between you and the Company or any of its
                professionals.
              </span>
            </span>
          </p>
          <p style={{ textAlign: 'justify', lineHeight: '0.23in', marginBottom: '0in' }}>
            <span style={{ border: 'none', padding: '0in' }}>
              <span lang="en-US">
                <strong>User’s Personal Responsibility&nbsp;</strong>
              </span>
            </span>
          </p>
          <p style={{ textAlign: 'justify', lineHeight: '0.23in', marginBottom: '0in' }}>
            <br />
          </p>
          <p style={{ textAlign: 'justify', lineHeight: '100%', marginBottom: '0.18in' }}>
            <span>
              <span lang="en-US">
                By using this Website, you accept personal responsibility for the results of your
                actions. &nbsp;You agree to take full responsibility for any harm or damage you
                suffer as a result of the use, or non-use, of the information available on this
                Website or the resources available for download from this Website. You agree to use
                judgment and conduct due diligence before taking any action or implementing any plan
                or policy suggested or recommended on this Website.
              </span>
            </span>
          </p>
          <p style={{ textAlign: 'justify', lineHeight: '0.23in', marginBottom: '0in' }}>
            <span style={{ border: 'none', padding: '0in' }}>
              <span lang="en-US">
                <strong>No Guarantees</strong>
              </span>
            </span>
          </p>
          <p style={{ textAlign: 'justify', lineHeight: '0.23in', marginBottom: '0in' }}>
            <br />
          </p>
          <p style={{ textAlign: 'justify', lineHeight: '100%', marginBottom: '0.18in' }}>
            <span>
              <span lang="en-US">
                You agree that the Company has not made any guarantees about the results of taking
                any action, whether recommended on this Website or not. The Company provides
                educational and informational resources that are intended to help users of this
                website understand and navigate this field.&nbsp;
              </span>
            </span>
          </p>
          <p style={{ textAlign: 'justify', lineHeight: '0.23in', marginBottom: '0in' }}>
            <span style={{ border: 'none', padding: '0in' }}>
              <span lang="en-US">
                <strong>Errors And Omissions</strong>
              </span>
            </span>
          </p>
          <p style={{ textAlign: 'justify', lineHeight: '0.23in', marginBottom: '0in' }}>
            <br />
          </p>
          <p style={{ textAlign: 'justify', lineHeight: '100%', marginBottom: '0.18in' }}>
            <span>
              <span lang="en-US">
                We have taken reasonable steps to ensure that the information contained in this
                Website is accurate, but we cannot represent that the classes will be free of
                errors. You accept that the information contained on this Website may be erroneous
                and agree to conduct due diligence to verify any information obtained from this
                Website and/or resources available on it prior to taking any action. &nbsp;You
                expressly agree not to rely upon any information contained in this website.
              </span>
            </span>
          </p>
          <p style={{ textAlign: 'justify', lineHeight: '0.23in', marginBottom: '0in' }}>
            <span style={{ border: 'none', padding: '0in' }}>
              <span lang="en-US">
                <strong>No Warranties</strong>
              </span>
            </span>
          </p>
          <p style={{ textAlign: 'justify', lineHeight: '0.23in', marginBottom: '0in' }}>
            <br />
          </p>
          <p style={{ textAlign: 'justify', lineHeight: '100%', marginBottom: '0.18in' }}>
            <span>
              <span lang="en-US">
                The Company makes no warranties regarding the performance or operation of this
                website. The company further makes no representations or warranties of any kind,
                express or implied, as to the information, contents, materials, documents, programs,
                products, books, or services included on or through this website. To the fullest
                extent permissible under the law, the company disclaims all warranties, express or
                implied, including implied warranties of merchantability and fitness for a
                particular purpose.
              </span>
            </span>
          </p>
          <p style={{ textAlign: 'justify', lineHeight: '0.23in', marginBottom: '0in' }}>
            <span style={{ border: 'none', padding: '0in' }}>
              <span lang="en-US">
                <strong>Limitation of Liability</strong>
              </span>
            </span>
          </p>
          <p style={{ textAlign: 'justify', lineHeight: '100%', marginBottom: '0.18in' }}>
            <br />
            &nbsp;
          </p>
          <p style={{ textAlign: 'justify', lineHeight: '100%', marginBottom: '0.18in' }}>
            <span>
              <span lang="en-US">
                You agree to absolve the Company of any and all liability or loss that you or any
                person or entity associated with you may suffer or incur as a result of use of the
                information contained on this website and/or the resources you may download from
                this website. You agree that the company shall not be liable to you for any type of
                damages, including direct, indirect, special, incidental, equitable, or
                consequential loss or damages for use of this website.
              </span>
            </span>
          </p>
          <p style={{ textAlign: 'justify', lineHeight: '100%', marginBottom: '0.18in' }}>
            <span>
              <span lang="en-US">
                The information and services included in or available through the website may
                include inaccuracies or typographical errors. Changes are periodically added to the
                information herein. The company and/or its suppliers may make improvements and/or
                changes in the website at any time.
              </span>
            </span>
          </p>
          <p style={{ textAlign: 'justify', lineHeight: '100%', marginBottom: '0.18in' }}>
            <span>
              <span lang="en-US">
                The company and/or its suppliers make no representations about the suitability,
                reliability, availability, timeliness, and accuracy of the information, products,
                services and related graphics contained on the website for any purpose. To the
                maximum extent permitted by applicable law, all such information, products, services
                and related graphics are provided “as is” without warranty or condition of any kind.
                The company and/or its suppliers hereby disclaim all warranties and conditions with
                regard to this information, software, products, services and related graphics,
                including all implied warranties or conditions of merchantability, fitness for a
                particular purpose, title, and non-infringement.
              </span>
            </span>
          </p>
          <p style={{ textAlign: 'justify', lineHeight: '100%', marginBottom: '0.18in' }}>
            <span>
              <span lang="en-US">
                To the maximum extent permitted by applicable law, in no event shall the company
                and/or its suppliers be liable for any direct, indirect, punitive, incidental,
                special, consequential damages or any damages whatsoever including, without
                limitation, damages for loss of use, data or profits, arising out of or in any way
                connected with the use or performance of the website, with the delay or inability to
                use the website or related services, the provision of or failure to provide
                services, or for any information, software, products, services and related graphics
                obtained through the website, or otherwise arising out of the use of the website,
                whether based on contract, tort, negligence, strict liability or otherwise, even if
                the company or any of its suppliers has been advised of the possibility of damages.
                Because some states/jurisdictions do not allow the exclusion or limitation of
                liability for consequential or incidental damages, the above limitation may not
                apply to you. If you are dissatisfied with any portion of the website, or with any
                of these terms of use, your sole and exclusive remedy is to discontinue using the
                website.
              </span>
            </span>
          </p>
          <p
            style={{
              lineHeight: '115%',
              textAlign: 'justify',
              background: 'transparent',
              marginBottom: '0.14in',
            }}
          >
            <br />
            &nbsp;
          </p>
          <p style={{ lineHeight: '100%', textAlign: 'left', marginBottom: '0in' }}>
            <br />
          </p>
        </div>
      </div>
    </div>
  )
}

export default Disclaimer
